import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {PersonalInfoAgreementVo} from '../../common/shared/api/nicolas/vo/PersonalInfoAgreementVo.interface';

/**
 * 개인정보 동의 약관 조회
 *
 * Origin: pageNicolasApi.getPersonalInfoAgreement
 * API: GET /gateway/auth/v5/getagreement/personal_info
 */
export async function getAuthGetagreementPersonalInfo(
  params?: {
    accessToken?: string;
    appUserId?: number;
  },
  options?: FetcherOptions
): Promise<PersonalInfoAgreementVo> {
  const response = await axiosBffFetch(
    '/api/gateway/auth/v5/getagreement/personal_info',
    {
      method: 'GET',
      params: params
        ? {
            app_user_id: params.appUserId,
            access_token: params.accessToken,
          }
        : undefined,
    },
    options
  );

  return response.data;
}
